import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox, checkboxClasses, Stack, Typography } from '@mui/material';
/** @deprecated */
export const ItemTreeOnClickWrapper = ({ vob, selectable, selectedNodeIds, setSelectedNodeIds }) => {
    const selected = selectedNodeIds?.includes(vob.sk) ?? false;
    const toggle = () => {
        if (setSelectedNodeIds) {
            const clone = [...(selectedNodeIds ?? [])];
            const idx = clone.findIndex((sk) => sk === vob.sk);
            if (idx === -1) {
                clone.push(vob.sk);
            }
            else {
                clone.splice(idx, 1);
            }
            setSelectedNodeIds(clone);
        }
        else {
            throw new Error('ItemTreeOnClickWrapper requires setSelectedNodeIds');
        }
    };
    return (_jsxs(Stack, { direction: 'row', alignContent: 'center', gap: 1, children: [_jsx(Checkbox, { checked: selected, onChange: () => toggle(), disabled: !selectable, sx: {
                    [`&.${checkboxClasses.root}`]: {
                        padding: 0,
                    },
                } }), _jsx(Typography, { children: vob.name })] }));
};
